import { Navigate } from "react-router-dom";
import { useSiteStatus } from "@/context/SiteStatusContext";

// Bloque l'accès aux pages revendeur lorsque le module est désactivé par l'admin.
export default function ResellerGate({ children }) {
  const { resellers, loaded } = useSiteStatus();
  if (loaded && resellers?.enabled === false) return <Navigate to="/" replace />;
  return children;
}
